import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { Stack, Typography } from 'ui';

import { useAllDealInspections } from '../../hooks/useAllDealInspections/useAllDealInspections';

export const DealInspectionsList = ({ dealId }: { dealId: number }) => {
  const { t } = useTranslation('orders');
  const { data: inspections, isLoading } = useAllDealInspections(dealId);

  if (isLoading) {
    return <Typography variant="body2">{t('dealInspectionsList.states.loadingRelatedInspections')}</Typography>;
  }

  if (!inspections?.results.length) {
    return <Typography variant="body2">{t('dealInspectionsList.states.noRelatedInspections')}</Typography>;
  }

  return (
    <Stack direction="row" spacing={2} useFlexGap data-testid="deal-inspections-list" sx={{ flexWrap: 'wrap' }}>
      {inspections.results.map(({ id, slug }) => (
        <Link key={id} to={`/ground-control/inspections/${id}/`}>
          {slug}
        </Link>
      ))}
    </Stack>
  );
};
